import { createContext } from "react";
import type { OpenAddWidgetDialogState } from "../OpenAddWidgetDialogProvider.types";

const OpenAddWidgetDialogStateContext = createContext<OpenAddWidgetDialogState | undefined>(undefined);
OpenAddWidgetDialogStateContext.displayName = "OpenAddWidgetDialogStateContext";

export default OpenAddWidgetDialogStateContext;
